import axiosInstance from '@/app/api/axiosInstance';
import { UserAccessibleOrganizationsResponse } from '@/app/types/organization_access';
import { Site } from '@/app/types/site';

export const getMyOrganizations = async (): Promise<UserAccessibleOrganizationsResponse> => {
  const response = await axiosInstance.get<UserAccessibleOrganizationsResponse>(
    '/organization-access/me/organizations'
  );
  return response.data;
};

export const getAccessibleSitesInOrg = async (organizationId: number): Promise<Site[]> => {
  const response = await axiosInstance.get<Site[]>('/sites/accessible', {
    params: { organization_id: organizationId }
  });
  return response.data;
};

export const switchOrganization = async (
  organizationId: number,
  siteId?: number
): Promise<void> => {
  await axiosInstance.patch('/user-preferences/me', {
    default_organization_id: organizationId,
    ...(siteId && { default_site_id: siteId })
  });
};
